import DocsIcon from '@/assets/icons/docs.svg?react';
import type { IngredientArticle } from '@/domain/Ingredient';

interface IngredientArticleRowProps {
  article: IngredientArticle;
}

export const IngredientArticleRow = ({
  article,
}: IngredientArticleRowProps) => {
  return (
    <div className="flex items-start gap-4.5">
      <DocsIcon className="text-primary size-7.5 shrink-0" />

      <div className="flex flex-col gap-3">
        <p className="font-medium">{article.description}</p>
        <p>{article.source}</p>
      </div>
    </div>
  );
};
